import { NavigationGroup, NavigationGroupTypes, NavigationItem, NavigationLayoutTypes, NavigationSection, NavigationState } from '@common/store/navigation/models/navigation.models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

export const NavigationActions = createActionGroup({
    source: 'Navigation',
    events: {
        'Initialize navigation data': emptyProps(),
        'Initialize navigation data success': props<{ state: NavigationState }>(),
        'Initialize navigation data error': props<{ error: string }>(),

        'Initialize team navigation data': emptyProps(),
        'Initialize team navigation data success': props<{ sections: Array<NavigationSection> }>(),
        'Initialize team navigation data error': props<{ error: string }>(),

        'Clear navigation data': emptyProps(),
        'Store navigation data': emptyProps(),
        'Store navigation data success': emptyProps(),
        'Store navigation data error': props<{ error: string }>(),

        'Load navigation data': emptyProps(),
        'Load navigation data success': props<{ state: NavigationState }>(),
        'Load navigation data error': emptyProps(),

        'Retrieve navigation data': emptyProps(),

        'Set application': props<{ application: string }>(),
        'Add group': props<{ application: string; group: NavigationGroup }>(),
        'Update group': props<{ group: NavigationGroup }>(),
        'Update group state': props<{ group: NavigationGroup }>(),

        'Add section': props<{ group: NavigationGroup; section: NavigationSection }>(),
        'Remove section': props<{ group: NavigationGroup; section: NavigationSection }>(),
        'Update section': props<{ group: NavigationGroup; section: NavigationSection }>(),
        'Update section state': props<{ group: NavigationGroup; section: NavigationSection }>(),

        'Add item': props<{ application: string; group: NavigationGroup; section: NavigationSection; item: NavigationItem }>(),
        'Remove item': props<{ group: NavigationGroup; section: NavigationSection; item: NavigationItem }>(),
        'Remove item from groups': props<{ vs: ViewStateRecord; groups: Array<number>; delete?: boolean }>(),

        'Set current item': props<{ group: string; section: string; item: string }>(),
        'Set single current item': props<{ item: string }>(),

        'Navigate to default item': emptyProps(),
        'Navigate to item': props<{ item: NavigationItem }>(),
        'Enter search mode': props<{ term: string }>(),
        'Load navigation item': props<{ vs: ViewStateRecord }>(),
        'Load single navigation item': props<{ guid: string }>(),
        'Set single navigation item data': props<{ itemtype: ObjectTypes; title: string }>(),
        'Reorder Items': props<{ group: NavigationGroup; sourceSection: NavigationSection; targetSection: NavigationSection; sourceIndex: number; targetIndex: number; guid: string }>(),
    },
});

export const NavigationApiActions = createActionGroup({
    source: 'Navigation API',
    events: {
        'Save navigation': props<{ application: string; layout: NavigationLayoutTypes; team: string; sections: Array<NavigationSection>; section: NavigationSection }>(),
        'Save navigation success': props<{ status: boolean }>(),
        'Save navigation error': props<{ error: string }>(),

        'Save current navigation item': emptyProps(),
        'Save current navigation item success': props<{ status: boolean }>(),
        'Save current navigation item error': props<{ error: string }>(),

        'Load team navigation data': props<{ team: string }>(),
        'Load team navigation data success': props<{ navigation: any }>(),
        'Load team navigation data error': props<{ error: string }>(),

        'Create navigation item': props<{ vs: ViewStateRecord }>(),
        'Create navigation item success': props<{ group: NavigationGroup; section: NavigationSection; item: NavigationItem; vs: ViewStateRecord }>(),
        'Create navigation item error': props<{ error: string }>(),

        'Add navigation item': props<{ group: number; section: number; vs: ViewStateRecord }>(),
        'Add navigation item success': props<{ group: NavigationGroup; section: NavigationSection; item: NavigationItem; vs: ViewStateRecord }>(),
        'Add navigation item error': props<{ error: string }>(),

        'Update navigation item': props<{ vs: ViewStateRecord }>(),
        'Update navigation item success': props<{ vs: ViewStateRecord }>(),
        'Update navigation item error': props<{ error: string }>(),

        'Set default navigation item': props<{ guid: string; layout: NavigationLayoutTypes; group: NavigationGroupTypes; team: string }>(),
        'Set default navigation item success': props<{ status: boolean; group: NavigationGroupTypes; guid: string }>(),
        'Set default navigation item error': props<{ error: string }>(),
    },
});
